import React from 'react';
import searchIcon from '../icons/non-prefilled/16x16/search.svg';
import SVGIcon from './SVGIcon';
import * as styles from './SearchInput.module.scss';

interface SearchInputProps {
  autoFocus?: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  value?: string;
}

const SearchInput = React.forwardRef(
  (
    {
      autoFocus = undefined,
      onChange,
      placeholder = 'Search',
      value = '',
    }: SearchInputProps,
    ref: React.Ref<HTMLInputElement>,
  ) => {
    return (
      <label className={styles.container}>
        <SVGIcon className={styles.icon}>{searchIcon}</SVGIcon>
        <input
          aria-label="Search"
          autoFocus={autoFocus}
          className={styles.input}
          onChange={onChange}
          type="text"
          ref={ref}
          placeholder={placeholder}
          value={value}
        />
      </label>
    );
  },
);

export default SearchInput;
